import { GridRowsProp } from "@mui/x-data-grid";
import { motion } from "motion/react";
import { useMemo } from "react";

import StatusFilterItem from "@/components/table/StatusFilterItem";
import { userTypes } from "@/constants/userTypes";
import { useUsersTableActions, useUsersTableFilters } from "@/stores/use-users-table";
import { UserType } from "@/types/user.types";

export function UserStatusFilter({ allRows }: { allRows: GridRowsProp }) {
    const filters = useUsersTableFilters();
    const { updateFilters } = useUsersTableActions();
    const activeStyle = useMemo(() => {
        for (const [index, item] of userTypes.filter((item) => item.show).entries()) {
            if (filters.userType && item.values.includes(filters.userType))
                return { translateX: `${index * 100}%`, backgroundColor: item.hover };
        }
        return false;
    }, [filters, userTypes]);
    const vals = useMemo(
        () =>
            (allRows || []).reduce(
                (prev, curr) => {
                    const value = userTypes.find((item) => item.values.includes(curr.userType))?.values[0];
                    if (value) prev[value] += 1;
                    return prev;
                },
                {
                    [UserType.DRIVER]: 0,
                    [UserType.WELCOME_TEAM_OFFICER]: 0,
                    [UserType.MANAGER]: 0,
                }
            ),
        [allRows]
    );

    const handleUpdate = (status: UserType) => {
        updateFilters({ userType: filters.userType === status ? null : status });
    };

    const filterElements = useMemo(
        () =>
            userTypes
                .filter((item) => item.show)
                .map((item) => (
                    <StatusFilterItem
                        key={item.tooltip.title}
                        {...item}
                        active={!!(filters.userType && item.values.includes(filters.userType))}
                        count={vals[item.values[0]]}
                        handleUpdate={handleUpdate}
                    />
                )),
        [filters, vals]
    );
    return (
        <div className=" relative py-1 h-full grid grid-cols-3 bg-gray-100/80  divide-x divide-gray-300    rounded">
            {filterElements}
            {activeStyle && (
                <motion.div
                    layoutId="hotel-status-filter"
                    id="hotel-status-filter"
                    animate={activeStyle}
                    transition={{ type: "tween" }}
                    className="  rounded-none absolute   !self-center  !h-[calc(100%-8px)]     !w-1/3 "
                ></motion.div>
            )}
        </div>
    );
}
